module.exports = __webpack_public_path__ + "90D8CADA833262A7projects-2.e4e5484a.png";